import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { helperFunction } from "../../../../constant/helper/index";
import { tableSkeleton } from "../../../../constant/helper/helper";
import DprList from "./DprList";
import Starter from "../../../../component/Starter";
import TopInput from "./TopInput";
import {
  clearDprErrors,
  clearDprResult,
  getAllDpr,
  setDprLoading
} from "../../../../redux/actions/dprActions";

const initialState = {
  date: "",
  locationId: ""
};

const GetDpr = (props) => {
  const loginType = localStorage.loginType;
  const dispatch = useDispatch();

  const [allDpr, setAllDpr] = useState([]);
  const [values, setValues] = useState(initialState);
  const [allLocations, setAllLocations] = useState({});

  const { currentUser } = useSelector((state) => state.auth);
  const { locations } = useSelector((state) => state.location);
  const {
    dprs,
    dprLoading,
    dprError,
    dprDate,
    dprLocation
  } = useSelector((state) => state.dpr);

  useEffect(() => {
    if (locations !== null) {
      setAllLocations(locations);
    } else {
      setAllLocations([]);
    }
  }, [locations]);

  useEffect(() => {
    if (dprs !== null) {
      setAllDpr(dprs);
    } else {
      setAllDpr([]);
    }
  }, [dprs]);

  useEffect(() => {
    setValues({
      ...values,
      date: dprDate,
      locationId: dprLocation
    });
  }, [dprDate, dprLocation]);

  useEffect(() => {
    dispatch(setDprLoading(false));
    dispatch(clearDprErrors());
    dispatch(clearDprErrors());
    return () => {
      dispatch(setDprLoading(false));
      dispatch(clearDprErrors());
      dispatch(clearDprErrors());
    };
  }, []);

  useEffect(() => {
    if (dprError) {
      helperFunction.toastHelper("error", dprError);
    }
  }, [dprError]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setValues({
      ...values,
      [name]: value
    });
  };

  const fetchQueryFromDate = (e) => {
    e.preventDefault();
    dispatch(setDprLoading(true));
    dispatch(clearDprResult());
    dispatch(clearDprErrors());

    dispatch(getAllDpr(values.date, values.locationId, loginType));
  };

  const showDPRList = (dprListArray) => {
    if (dprLoading) {
      return <tr>{tableSkeleton(5)}</tr>;
    } else if (dprListArray === null) {
      return (
        <tr style={{ top: "50%", left: "50%", position: "fixed" }}>
          <td>
            <span className="">Please Select Date</span>
          </td>
        </tr>
      );
    } else if (dprListArray.length === 0) {
      return (
        <tr style={{ top: "50%", left: "50%", position: "fixed" }}>
          <td>
            <span className="">
              No Record Found for date {values.date}
            </span>
          </td>
        </tr>
      );
    } else if (
      typeof dprListArray !== "undefined" &&
      dprListArray !== null &&
      dprListArray.length > 0
    ) {
      return dprListArray.map((dprItem, index) => (
        <DprList key={index} dprItem={dprItem} index={index} />
      ));
    }
  };

  return (
    <Starter
      topBarTitle="All DPR"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">DPR Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">DPR</a>
          </li>
          <li className="breadcrumb-item active">All DPR</li>
        </Fragment>
      }
    >
      <TopInput
        values={values}
        allLocations={
          typeof allLocations !== "undefined" &&
          allLocations.length > 0
            ? allLocations
            : []
        }
        loading={dprLoading}
        onChange={handleInputChange}
        onSubmit={fetchQueryFromDate}
        currentUser={currentUser}
      />
      <div
        className="table-responsive"
        // ref={componentRef}
        style={{
          height: "700px",
          overflow: "auto"
        }}
      >
        <table
          className="table table-bordered table-centered mb-0 table-hover w-100 dt-responsive nowrap"
          id="products-datatable"
        >
          <thead className="thead-light">
            <tr>
              <th style={{ width: "20px" }}>#</th>
              <th>Date</th>
              <th>Location</th>
              <th>User Id</th>
              <th>Report Prepared By</th>
            </tr>
          </thead>
          <tbody>{showDPRList(allDpr)}</tbody>
        </table>
      </div>
    </Starter>
  );
};

export default GetDpr;
